import { EventEmitter, Injectable } from '@angular/core';

@Injectable()
export class SideBarService {
	activeMenuItem?: string;
	activeMenuItemUpdated: EventEmitter<string> = new EventEmitter<string>();

	setActiveMenuItem(val?: string) {
		this.activeMenuItem = val;
		this.activeMenuItemUpdated.emit(this.activeMenuItem);
	}

	getActiveMenuItem() {
		return this.activeMenuItem;
	}
}
